import { render, staticRenderFns } from "./ShowImage.vue?vue&type=template&id=01752fec"
import script from "./ShowImage.vue?vue&type=script&lang=js"
export * from "./ShowImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01752fec')) {
      api.createRecord('01752fec', component.options)
    } else {
      api.reload('01752fec', component.options)
    }
    module.hot.accept("./ShowImage.vue?vue&type=template&id=01752fec", function () {
      api.rerender('01752fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/avatar/ShowImage.vue"
export default component.exports